(function () {
  'use strict';

  /* ---------------------------------------------------------------
     AI náhled obrazu na zdi z návštěvníkovy fotky (produktová stránka).
     Fotka i obrázek díla se posílají na samostatný server (Vercel),
     který bezpečně volá OpenAI. Klíč nikdy neopustí server.
     --------------------------------------------------------------- */
  // /api/umisteni vraci JEN souradnice volne zdi (a u doporucovace vybrana
  // dila). Obraz do fotky poklada prohlizec - viz assets/scena.js.
  var UMISTENI_API_URL = 'https://galelie-ai-preview.vercel.app/api/umisteni';

  // Napoveda k posouvani je jedina veta navic, tak se nevozi pres datove
  // atributy ze sablon (musely by se upravit dve sekce), ale bere se podle
  // jazyka stranky. Ostatni popisky chodi ze sablon dal jako dosud.
  var NAPOVEDY = {
    cs: 'Obraz posuňte prstem, dvěma prsty ho zvětšíte. Na počítači kolečkem myši.',
    en: 'Drag the picture with your finger, pinch to resize. Use the scroll wheel on a computer.',
    de: 'Bild mit dem Finger verschieben, mit zwei Fingern vergrößern. Am Computer mit dem Mausrad.',
    es: 'Arrastre el cuadro con el dedo y pellizque para cambiar el tamaño. En el ordenador, con la rueda del ratón.',
    fr: 'Déplacez le tableau avec le doigt, pincez pour redimensionner. Sur ordinateur, avec la molette.',
    it: 'Sposta il quadro con il dito, pizzica per ridimensionare. Sul computer con la rotellina.',
    nl: 'Versleep het schilderij met je vinger, knijp om te vergroten. Op de computer met het muiswiel.',
    pl: 'Przesuń obraz palcem, uszczypnij, aby zmienić rozmiar. Na komputerze kółkiem myszy.',
    pt: 'Arraste o quadro com o dedo e junte os dedos para redimensionar. No computador, com a roda do rato.',
    hu: 'Mozgassa a képet az ujjával, két ujjal átméretezheti. Számítógépen az egérgörgővel.',
    uk: 'Перетягніть картину пальцем, двома пальцями змініть розмір. На комп’ютері коліщатком миші.'
  };

  function napoveda() {
    var kod = (document.documentElement.lang || 'cs').slice(0, 2).toLowerCase();
    return NAPOVEDY[kod] || NAPOVEDY.cs;
  }

  (function productPreview() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('[data-ai-preview]'));
    if (!widgets.length) return;

    widgets.forEach(function (widget) {
      var input = widget.querySelector('[data-ai-preview-input]');
      var status = widget.querySelector('[data-ai-preview-status]');
      var resultBox = widget.querySelector('[data-ai-preview-result]');
      var resultImg = widget.querySelector('[data-ai-preview-image]');
      var closeButton = widget.querySelector('[data-ai-preview-close]');
      var artworkUrl = widget.dataset.artworkUrl;
      var title = widget.dataset.title || '';
      var uploadingLabel = widget.dataset.uploadingLabel || '…';
      var errorLabel = widget.dataset.errorLabel || '';
      if (!input || !artworkUrl) return;

      var scena = null;

      function closeResult() {
        if (!resultBox) return;
        resultBox.hidden = true;
        if (scena) { scena.znic(); scena = null; }
        if (resultImg) {
          if (resultImg.src && resultImg.src.indexOf('blob:') === 0) {
            URL.revokeObjectURL(resultImg.src);
          }
          resultImg.removeAttribute('src');
        }
      }

      if (closeButton) {
        closeButton.addEventListener('click', closeResult);
      }

      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) return;

        closeResult();
        setStatus(status, uploadingLabel, 'loading');

        // Fotka se ukaze OKAMZITE i s obrazem na ni; navrh ze serveru dorazi
        // az potom. Navstevnik tak nema prazdnou obrazovku a muze hybat hned.
        scena = postavScenu(resultBox, resultImg, file, [{
          title: title,
          url: '',
          image: artworkUrl
        }]);
        if (resultBox) resultBox.hidden = false;

        var form = new FormData();
        form.append('room', file);

        fetch(UMISTENI_API_URL, { method: 'POST', body: form })
          .then(function (res) {
            if (!res.ok) throw new Error('bad status ' + res.status);
            return res.json();
          })
          .then(function (data) {
            if (scena && data && data.zed) scena.navrhni(data.zed);
            setStatus(status, '');
          })
          .catch(function () {
            // Návrh nedorazil, ale obraz je na fotce a jde s ním hýbat —
            // není tedy co hlásit jako chybu, jen zmizí „pracuji".
            setStatus(status, '');
          })
          .finally(function () {
            input.value = '';
          });
      });
    });
  })();

  /* ---------------------------------------------------------------
     AI doporučovač na homepage.

     Postup (2026-09-10 na prani majitelky): navstevnik nahraje fotku
     zdi, ale hledat se zacne az potom, co si vybere sekci - jestli chce
     zvirata, abstrakci nebo cokoli jineho. Nabidka sekci se bere ze
     skutecnych kolekci obchodu (<script data-ai-collections>), takze se
     sama zmeni, kdyz majitelka kolekce upravi.

     Prirazeni dila k sekci se odviji od tagu produktu - stejna dohoda,
     na ktere stoji i filtr nad vypisem del. Sekce, do ktere by v katalogu
     nespadlo zadne dilo, se nenabizi.
     --------------------------------------------------------------- */
  (function homeRecommend() {
    var widget = document.querySelector('[data-ai-recommend]');
    if (!widget) return;

    var catalogScript = document.querySelector('[data-ai-catalog]');
    var catalogUrl = widget.dataset.catalogUrl || '';
    var collectionsScript = document.querySelector('[data-ai-collections]');
    var input = widget.querySelector('[data-ai-recommend-input]');
    var status = widget.querySelector('[data-ai-recommend-status]');
    var resultsBox = widget.querySelector('[data-ai-recommend-results]');
    var fallback = widget.querySelector('[data-ai-recommend-fallback]');
    var uploadingLabel = widget.dataset.uploadingLabel || '…';
    var errorLabel = widget.dataset.errorLabel || '';
    var viewLabel = widget.dataset.viewLabel || '';
    if (!input || (!catalogScript && !catalogUrl)) return;

    var catalog = null;
    var themes = null;
    var catalogRequest = null;
    var chooseLabel = (collectionsScript && collectionsScript.dataset.chooseLabel) || '';
    var pendingFile = null;
    var themesBox = null;
    var activeButton = null;
    // Téma, na které někdo klepl dřív, než dorazil katalog.
    var cekajiciTema = null;

    /**
     * Katalog del. Od 2026-09-15 uz neni vlozeny ve strance (skladal se
     * pres vsech 148 produktu a byl nejvetsi polozkou jejiho vykresleni),
     * ale stahuje se z /collections/all?view=ai-katalog. Stahuje se jen
     * jednou; kdyz se nepovede, priste to smi zkusit znovu.
     */
    function loadCatalog() {
      if (catalogRequest) return catalogRequest;

      if (catalogScript) {
        // Starsi podoba stranky, kde je katalog jeste primo v HTML.
        catalogRequest = new Promise(function (resolve) {
          resolve(checkCatalog(JSON.parse(catalogScript.textContent)));
        });
      } else {
        catalogRequest = fetch(catalogUrl, { credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) throw new Error('bad status ' + res.status);
            return res.text();
          })
          .then(function (text) {
            return checkCatalog(JSON.parse(text));
          });
      }

      catalogRequest.catch(function () {
        catalogRequest = null;
      });

      return catalogRequest;
    }

    function checkCatalog(data) {
      if (!Array.isArray(data) || !data.length) throw new Error('empty catalog');
      return data;
    }

    // Predehrati: az kdyz je stranka nactena a prohlizec nema nic na praci,
    // aby stahovani katalogu nesoutezilo s obrazky uvodni sceny.
    function warmCatalog() {
      var start = function () {
        loadCatalog().catch(function () {});
      };
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(start, { timeout: 4000 });
      } else {
        window.setTimeout(start, 2000);
      }
    }
    if (document.readyState === 'complete') {
      warmCatalog();
    } else {
      window.addEventListener('load', warmCatalog, { once: true });
    }

    input.addEventListener('change', function () {
      var file = input.files && input.files[0];
      // Vstup se uvolni hned - jinak by opakovany vyber TEHOZ souboru
      // nevyvolal udalost change.
      input.value = '';
      if (!file) return;

      pendingFile = file;
      cekajiciTema = null;
      clearResults();

      // Nabídka témat se skládá ze seznamu kolekcí, který je ve stránce od
      // začátku — ukáže se tedy OKAMŽITĚ. Katalog děl (naměřeno 9 s při první
      // návštěvě) dobíhá na pozadí a je potřeba až po výběru tématu.
      if (!themes) themes = rychlaTemata();
      setStatus(status, '');
      showThemes();

      loadCatalog()
        .then(function (data) {
          catalog = data;
          srovnejTemata();
          // Když někdo klepl dřív, než katalog dorazil, teď se to rozjede.
          if (cekajiciTema && pendingFile === file) {
            var t = cekajiciTema;
            cekajiciTema = null;
            run(polozkyTematu(t), t);
          }
        })
        .catch(function () {
          if (pendingFile !== file) return;
          cekajiciTema = null;
          setStatus(status, errorLabel, 'error');
          if (fallback) fallback.hidden = false;
        });
    });


    /**
     * Nabídka témat ze seznamu kolekcí, který je ve stránce od začátku.
     * Díla se k tématům přiřadí až z katalogu — do té doby je `items` prázdné.
     */
    function rychlaTemata() {
      if (!collectionsScript) return [];
      var kolekce;
      try {
        kolekce = JSON.parse(collectionsScript.textContent);
      } catch (err) {
        return [];
      }
      if (!Array.isArray(kolekce) || !kolekce.length) return [];

      var seznam = kolekce
        .filter(function (c) { return c && c.handle && c.title; })
        .map(function (c) { return { handle: c.handle, title: c.title, items: null }; });

      if (!seznam.length) return [];
      seznam.unshift({ handle: 'all', title: popisekVse(), items: null });
      return seznam;
    }

    /** Díla spadající do tématu; bez katalogu se to vědět nedá. */
    function polozkyTematu(t) {
      if (!catalog || !t) return null;
      if (t.handle === 'all') return catalog;
      return catalog.filter(function (p) {
        return Array.isArray(p.tags) && p.tags.indexOf(t.handle) !== -1;
      });
    }

    /**
     * Jakmile dorazí katalog, z nabídky zmizí témata, ve kterých nakonec
     * žádné dílo není. Dřív se nenabízela vůbec — teď zmizí o chvíli
     * později, což je pořád lepší než čekat na celou nabídku.
     */
    function srovnejTemata() {
      if (!themes || !themesBox) return;
      themes.forEach(function (t, i) {
        var polozky = polozkyTematu(t);
        t.items = polozky;
        var tlacitko = themesBox.querySelectorAll('.ai-recommend-theme')[i];
        if (tlacitko) tlacitko.hidden = !(polozky && polozky.length);
      });
    }
    /** Nabidka sekci; kdyz zadna nevyjde, jde se rovnou na cely katalog. */
    function showThemes() {
      if (!themes || !themes.length) {
        // Bez nabídky se jede rovnou na celý katalog; ten ale nemusí být
        // ještě stažený, tak se počká přes `cekajiciTema`.
        var cely = { handle: 'all', title: '', items: null };
        if (catalog) run(catalog, null);
        else {
          cekajiciTema = cely;
          setStatus(status, uploadingLabel, 'loading');
        }
        return;
      }
      if (!themesBox) {
        themesBox = buildThemesBox();
        widget.insertBefore(themesBox, resultsBox || null);
      }
      themesBox.hidden = false;
    }

    function buildThemesBox() {
      var box = document.createElement('div');
      box.className = 'ai-recommend-themes';

      if (chooseLabel) {
        var label = document.createElement('p');
        label.className = 'ai-recommend-themes-label';
        label.textContent = chooseLabel;
        box.appendChild(label);
      }

      var list = document.createElement('div');
      list.className = 'ai-recommend-theme-list';
      themes.forEach(function (theme) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ai-recommend-theme';
        button.textContent = theme.title;
        button.addEventListener('click', function () {
          if (activeButton) activeButton.classList.remove('is-active');
          activeButton = button;
          button.classList.add('is-active');

          var polozky = polozkyTematu(theme);
          if (polozky) {
            cekajiciTema = null;
            run(polozky, theme);
          } else {
            // Katalog ještě nedorazil — počká se a pak se to rozjede samo.
            cekajiciTema = theme;
            clearResults();
            setStatus(status, uploadingLabel, 'loading');
          }
        });
        list.appendChild(button);
      });
      box.appendChild(list);

      return box;
    }

    var scena = null;

    function clearResults() {
      if (scena) { scena.znic(); scena = null; }
      if (resultsBox) {
        resultsBox.hidden = true;
        resultsBox.innerHTML = '';
      }
      if (fallback) fallback.hidden = true;
    }

    /** Odesle fotku + vybranou cast katalogu na server. */
    function run(items, theme) {
      if (!pendingFile || !items || !items.length) return;

      clearResults();
      setStatus(status, uploadingLabel, 'loading');

      var form = new FormData();
      form.append('room', pendingFile);
      form.append('catalog', JSON.stringify(items));
      if (theme) form.append('theme', theme.title);

      fetch(UMISTENI_API_URL, { method: 'POST', body: form })
        .then(function (res) {
          if (!res.ok) throw new Error('bad status ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var picks = (data && data.picks) || [];
          if (resultsBox && picks.length) {
            // Vybraná díla se poskládají na návštěvníkovu fotku rovnou tady;
            // mezi dvěma se přepíná náhledy pod obrázkem.
            scena = postavScenu(resultsBox, null, pendingFile, picks, viewLabel);
            if (scena && data.zed) scena.navrhni(data.zed);
            resultsBox.hidden = false;
          }
          setStatus(status, '');
          if (fallback) fallback.hidden = false;
        })
        .catch(function () {
          setStatus(status, errorLabel, 'error');
          if (fallback) fallback.hidden = false;
        });
    }
  })();

  /**
   * Sestavi nabidku sekci: prvni je vzdy "vsechna dila", pak kolekce,
   * ktere v katalogu maji aspon jedno dilo. Nazev pro "vsechna dila" se
   * bere z tlacitka filtru na strance, aby nebylo potreba dalsi preklad.
   */
  function buildThemes(catalog, collectionsScript) {
    var themes = [];
    if (!collectionsScript) return themes;

    var collections;
    try {
      collections = JSON.parse(collectionsScript.textContent);
    } catch (err) {
      return themes;
    }
    if (!Array.isArray(collections) || !collections.length) return themes;

    collections.forEach(function (c) {
      if (!c || !c.handle || !c.title) return;
      var items = catalog.filter(function (p) {
        return Array.isArray(p.tags) && p.tags.indexOf(c.handle) !== -1;
      });
      if (items.length) themes.push({ handle: c.handle, title: c.title, items: items });
    });

    if (!themes.length) return themes;

    themes.unshift({ handle: 'all', title: popisekVse(), items: catalog });

    return themes;
  }

  /**
   * Postaví scénu do daného boxu. `skryjObrazek` je původní <img> s hotovým
   * náhledem — ten už se nepoužívá, ale ve značce zůstává, aby se šablony
   * nemusely měnit; jen se schová.
   */
  function postavScenu(box, skryjObrazek, soubor, dila, koupitLabel) {
    if (!box || !soubor || !window.GalelieScena) return null;
    if (skryjObrazek) skryjObrazek.hidden = true;

    var obal = box.querySelector('[data-scena]');
    if (!obal) {
      obal = document.createElement('div');
      obal.setAttribute('data-scena', '');
      box.appendChild(obal);
    }

    return window.GalelieScena.vytvor(obal, {
      fotkaUrl: URL.createObjectURL(soubor),
      dila: dila,
      texty: { napoveda: napoveda(), koupit: koupitLabel || '' }
    });
  }

  /**
   * Název pro „všechna díla" se bere z tlačítka filtru nad výpisem děl,
   * aby nebylo potřeba další překlad.
   */
  function popisekVse() {
    var tlacitko = document.querySelector('[data-filter="all"]');
    return (tlacitko && tlacitko.textContent.trim()) || 'Vše';
  }

  function buildCard(pick, viewLabel) {
    var a = document.createElement('a');
    a.className = 'ai-recommend-card';
    a.href = pick.url || '#';

    var img = document.createElement('img');
    img.src = pick.image;
    img.alt = pick.title || '';
    a.appendChild(img);

    var body = document.createElement('div');
    body.className = 'ai-recommend-card-body';

    var title = document.createElement('p');
    title.className = 'ai-recommend-card-title';
    title.textContent = pick.title || '';
    body.appendChild(title);

    var link = document.createElement('span');
    link.className = 'ai-recommend-card-link';
    link.textContent = viewLabel || 'Zobrazit';
    body.appendChild(link);

    a.appendChild(body);
    return a;
  }

  function setStatus(status, text, state) {
    if (!status) return;
    if (!text) {
      status.hidden = true;
      status.removeAttribute('data-state');
      status.textContent = '';
      return;
    }
    status.hidden = false;
    if (state) {
      status.setAttribute('data-state', state);
    } else {
      status.removeAttribute('data-state');
    }
    status.innerHTML = '';
    if (state === 'loading') {
      var spinner = document.createElement('span');
      spinner.className = 'ai-preview-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      status.appendChild(spinner);
    }
    var label = document.createElement('span');
    label.textContent = text;
    status.appendChild(label);
  }
})();
